<template>
  <div>
    <div v-if="$store.state.pageLoaded">
      <h1 class="md-headline theatre-title" v-if="$store.state.selectedObject !== null">
        {{ $store.state.selectedObject.title_hr }}
      </h1>
      <div class="theatre-container theatre-container-admin">
        <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="$store.dispatch('setActiveTab', $store.state.previousTab.tab)">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <AdminTheatre/>
        <div v-if="$store.state.selectedSeats.length > 0" class="selected-tickets selected-seats">
          <md-card>
            <SelectedSeats :discount="discount"/>
            <md-card-content>
              <div v-if="$store.state.currentTransaction.status == 'partner_checkout'">
                <md-field>
                  <label>Odaberi zakup</label>
                  <md-select v-model="partnerID">
                    <md-option v-for="partner in $store.state.receivedData.partners.list" :value="partner.id">{{ getTitle('partners', 'title', partner.id) }}</md-option>
                  </md-select>
                </md-field>
                <md-datepicker v-model="expiry" md-immediately>
                  <label>Vrijedi do</label>
                </md-datepicker>
              </div>
              <md-field v-if="$store.state.currentTransaction.status == 'reservation'">
                <label>Napomena</label>
                <md-input v-model="note"/>
              </md-field>
              <md-field v-if="Object.keys($store.state.currentTransaction.data.extra_seats).length > 0">
                <label>Proscenij</label>
                <md-input v-model="proscenium"/>
              </md-field>
              <p>Odabrano sjedala: <strong>{{ getSelectedSeats.length }}</strong></p>
              <p>Ukupna cijena: <strong>{{ formatCurrency(amount) }}</strong></p>
            </md-card-content>
            <md-card-actions>
              <md-list-item>
                <md-button class="md-raised md-primary md-dense" v-on:click="pay = true">
                  Izmjeni
                </md-button>
                <md-button class="md-raised md-accent md-dense">
                  Odustani
                </md-button>
              </md-list-item>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
    <md-dialog :md-active.sync="pay" :md-click-outside-to-close="false" :md-close-on-esc="false" class="dialog-container md-scrollbar">
      <md-dialog-title>Način plaćanja</md-dialog-title>
        <md-card-content>
          <div class="md-layout centered">
            <h4>Ukupna cijena: <strong>{{ formatCurrency(amount) }}</strong></h4>
            <md-radio v-model="paymentType" value="cash">Gotovina</md-radio>
            <md-radio v-model="paymentType" value="card">Kartica</md-radio>
            <md-radio v-model="paymentType" value="virman">Virman</md-radio>
            <md-radio v-model="paymentType" value="coupon">Darovni bon</md-radio>
            <md-checkbox v-model="r1">R1 račun</md-checkbox>
          </div>
          <div v-if="paymentType == 'card'" class="md-layout">
            <md-field>
              <label>Tip kartice</label>
              <md-select v-model="card_type">
                <md-option value="american">American</md-option>
                <md-option value="diners">Diners</md-option>
                <md-option value="maestro">Maestro</md-option>
                <md-option value="master">Master</md-option>
                <md-option value="visa">VISA</md-option>
                <md-option value="discovery">Discovery</md-option>
                <md-option value="v-pay">V Pay</md-option>
                <md-option value="union-pay">UnionPay</md-option>
              </md-select>
            </md-field>
            <md-field>
              <label>Broj rata</label>
              <md-select v-model="installments">
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              </md-select>
            </md-field>
          </div>
          <div v-show="r1" class="md-layout">
            <md-field :class="messageClass('name', r1Data)">
              <label>Naziv poduzeća</label>
              <md-input type="text" required v-model="r1Data.name" disabled/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('address', r1Data)">
              <label>Adresa</label>
              <md-input type="text" required v-model="r1Data.address" disabled/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('city', r1Data)">
              <label>Grad</label>
              <md-input type="text" required v-model="r1Data.city" disabled/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('postal_code', r1Data)">
              <label>Poštanski broj</label>
              <md-input type="text" required v-model="r1Data.postal_code" disabled/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('oib', r1Data)">
              <label>OIB</label>
              <md-input type="text" required v-model="r1Data.oib" disabled/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button class="md-accent md-dense md-raised" v-on:click="pay = false">
              Odustani
            </md-button>
            <md-button class="md-primary md-dense md-raised" v-on:click="edit()">
              Izmjeni
            </md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SubscriberValidation from '../../mixins/subscriber-validator.js';
import FormatCurrency from '../../mixins/format-currency';
import PaymentType from '../../mixins/payment-type';


export default {
  name: 'EditTransaction',
  mixins: [FormatCurrency, PaymentType('fromTheatre')],
  data(){
    return {
      discount: false,
      selectedSeats: [],
      hasDiscount: false,
      partnerID: '',
      amount: 0,
      performance: null,
      pay: false,
      proscenium: '',
      note: '',
      r1: true,
      expiry: new Date(),
    }
  },

  computed:{
		...mapGetters([
      'getSelectedSeats',
      'getFullPrice',
      'isPageLoaded'
    ]),
  },

  methods:{
    getTitle(stateObject, key, id){
      let object = this.$store.state.receivedData[stateObject].list.filter((object) =>{return object.id == id})[0];
      return object !== undefined ? object[key] : '';
    },

    async setPrice(defaultDiscount=false){
      let categoryID = null;
      let discountID = null;
      if(defaultDiscount) discountID = this.defaultDiscount;
      else discountID = this.pricelistID;
      for(categoryID in this.$store.state.theatre.pricelist_data.category){
        this.$store.state.categories[categoryID].price = this.performance.pricelist_data.category[categoryID][discountID];
      }
    },

    async edit(){
      this.$store.state.selectedObject = JSON.parse(JSON.stringify(this.$store.state.currentTransaction))
      this.$store.dispatch('updateTransaction', {context: {'status':'aborted'}});
      await this.setTransaction();
      this.$store.dispatch('setActiveTab', 'transactionDetails')
    },

    async setTransaction(){
      this.selectedSeats = this.$store.getters.getSelectedSeats;
      let context = {
        'performance': this.$store.state.selectedObject.data.performance_id,
        'kind': 'performance',
        'start_time': this.$store.state.selectedObject.data.performance_time,
        'seat_updates':{
          'status': this.$store.state.selectedObject.status,
          'seats': this.$store.getters.getSeatWithRow,
        },
        'status': this.$store.state.selectedObject.status,
        'amount': this.amount,
        'getTheatre': true,
        'price_label': this.$store.state.selectedObject.data.price_label_id,
        'showTransaction': true,
        'partner': this.partnerID,
        'expiry_date': this.expiry,
        'payment_type': this.paymentType,
        'card_type': this.card_type,
        'installments': this.installments,
        'status': this.$store.state.selectedObject.status,
        'isTicket': true,
      }

      if(this.proscenium.length > 0){
        context.seat_updates['extra_seats'] = parseInt(this.proscenium);
        context['note'] = this.note;
      }

      this.$store.dispatch('createTransaction', {context});
    },

    async changeAmount(){
      await this.setPrice();

      this.amount = this.getFullPrice(this.discount);
      if(this.proscenium.toString().length > 0){
        this.amount = parseFloat(this.getFullPrice(this.discount)) + parseFloat(parseInt(this.proscenium)*parseFloat(this.performance.pricelist_data.category[0][this.pricelistID]))
      }
    }
  },

  watch: {
    getSelectedSeats(newValue, oldValue){
      let hasDiscount = false;
      for(let i = 0; i < newValue.length; i++){
        if(newValue[i].discount != newValue[i].price){
          hasDiscount = true;
          break;
        }
      }
      this.hasDiscount = hasDiscount;
    },

    async isPageLoaded(value){
      if(value){

      }
    },

    getSelectedSeats(value){
      if(value.length > 0){
        this.changeAmount();
      }
    },

    proscenium(){
      this.changeAmount();
    }
  }
}
</script>


<style scoped lang="scss">
.add-subscriber{
  margin: 0;
}

.theatre-title{
  position: absolute;
  margin: 0;
  right: 50px;
}

.theatre-container{
  .back-button{
    top: -5px;
    left: -20px;
  }

  .selected-seats{
    position: absolute;
    top: 0;
    right: 16px;
    width: 300px;

    .md-list{
      max-height: calc(100vh - 450px);
    }
  }
}

input[disabled="disabled"]{
  -webkit-text-fill-color: #ddd !important;
}

.md-field.md-disabled:after{
  opacity: 0.2
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EditTransaction.vue